import React from "react";
import { treatments } from "../mock/data";
import { Sparkles, Shield, Crown, Star, Heart, Gem, Plus, Hexagon, Circle } from "lucide-react";

const iconMap = {
  tooth: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
      <path d="M12 2c3 0 6 1.8 6 5.2 0 2.6-1.2 3.8-1.7 6.6-.4 2-.2 4.8-1.6 6.2-1.1 1.1-2.6.2-2.9-1.6-.2-1.2-.3-3-.3-4.4H12H10.5c0 1.4-.1 3.2-.3 4.4-.3 1.8-1.8 2.7-2.9 1.6-1.4-1.4-1.2-4.2-1.6-6.2C5.2 11 4 9.8 4 7.2 4 3.8 7 2 10 2" />
    </svg>
  ),
  sparkles: <Sparkles className="w-6 h-6" />,
  shield: <Shield className="w-6 h-6" />,
  crown: <Crown className="w-6 h-6" />,
  star: <Star className="w-6 h-6" />,
  heart: <Heart className="w-6 h-6" />,
  gem: <Gem className="w-6 h-6" />,
  plus: <Plus className="w-6 h-6" />,
  hex: <Hexagon className="w-6 h-6" />,
  circle: <Circle className="w-6 h-6" />,
};

export default function Treatments() {
  return (
    <section id="treatments" className="py-24 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="section-eyebrow">Full-Service Dentistry</div>
          <h2 className="mt-4 font-serif-display text-[44px] md:text-[64px] leading-[1.05] text-[#0e2b2b]">
            Our <span className="hero-italic">Treatments</span>
          </h2>
          <p className="mt-4 text-[15px] md:text-[16px] text-[#0e2b2b]/70">
            Comprehensive dental solutions for the whole family — all under one roof in Lucknow.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {treatments.map((t) => {
            const seoHref = t.href;

            const content = (
              <>
                <div className="w-12 h-12 rounded-2xl bg-white border border-[#0e2b2b]/10 flex items-center justify-center text-[#14a68e] group-hover:bg-[#14a68e] group-hover:text-white transition">
                  {iconMap[t.icon] || <Sparkles className="w-6 h-6" />}
                </div>
                <h3 className="mt-5 font-serif-display text-[22px] text-[#0e2b2b] leading-tight">{t.title}</h3>
                <p className="mt-3 text-[13.5px] text-[#0e2b2b]/70 leading-relaxed">{t.desc}</p>
              </>
            );

            return seoHref ? (
              <a
                key={t.title}
                href={seoHref}
                className="group block rounded-3xl p-6 bg-[#f6f7f4] border border-[#0e2b2b]/5 card-lift"
              >
                {content}
              </a>
            ) : (
              <div key={t.title} className="group rounded-3xl p-6 bg-[#f6f7f4] border border-[#0e2b2b]/5 card-lift">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
